import { AuthService } from "@js/services/AuthService";
import { AccountClient, ApplicationUserCrudClient } from "@src/apis/ModularClient";
import { IndexService } from "@js/services/IndexService";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class ReferFriendController {
  //Refer a friend
  referFriendName: string;
  referFriendSurname: string;
  referFriendEmail: string;
  referFriendBody: string;

  //universal email send functions
  sendingrefermessage: boolean;
  sentrefermessage: boolean;

  page: number = 1;
  referForm1: ng.IFormController;
  referForm2: ng.IFormController;
  companyWebsite: string;
  isBrickflowOrg: boolean = false;

  static $inject = [
    "$scope",
    "$rootScope",
    "$cookies",
    "$location",
    "$http",
    "AccountClient",
    "AuthService",
    "IndexService",
    "ApplicationUserCrudClient",
    "ODataHelper",
  ];

  constructor(
    private $scope: ng.IScope,
    private $rootScope: ng.IRootScopeService,
    private $cookies: ng.cookies.ICookiesService,
    private $location: ng.ILocationService,
    private $http: ng.IHttpService,
    private accountClient: AccountClient,
    private authService: AuthService,
    private indexService: IndexService,
    private applicationUserCrudClient: ApplicationUserCrudClient,
    private odataHelper: ODataHelper,
  ) {
    this.companyWebsite = sessionStorage.getItem("companyWebsite");
    this.isBrickflowOrg = this.companyWebsite == "https://brickflow.com";
  }

  next() {
    if (this.page === 1) {
      this.page = 2;
    }
  }

  back() {
    if (this.page === 2) {
      this.page = 1;
    }
  }

  go(path: string) {
    this.$location.path(path);
  }

  async sendRefer(): Promise<void> {
    this.sendingrefermessage = true;
    this.sentrefermessage = false;

    this.odataHelper
      .getOne(this.applicationUserCrudClient, {
        filter: { id: { eq: await this.indexService.currentUserId } },
        select: { firstName: true, lastName: true, email: true },
      })
      .then((response) => {
        this.accountClient
          .sendFriendReferralEmail(
            response.firstName,
            response.lastName,
            response.email,
            this.referFriendName,
            this.referFriendSurname,
            this.referFriendEmail,
            this.referFriendBody,
          )
          .then(() => {
            this.sendingrefermessage = false;
            this.sentrefermessage = true;
          });
      });
  }
}
